import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Conferma from "@/pages/Conferma";
import AgentLink from "@/pages/AgentLink";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import RequestsList from "@/pages/admin/RequestsList";
import RequestDetail from "@/pages/admin/RequestDetail";
import AgentsPage from "@/pages/admin/AgentsPage";
import SettingsPage from "@/pages/admin/SettingsPage";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/conferma" element={<Conferma />} />
      <Route path="/a/:slug" element={<AgentLink />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route element={<AdminLayout />}>
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/richieste" element={<RequestsList />} />
        <Route path="/admin/richieste/:id" element={<RequestDetail />} />
        <Route path="/admin/agenti" element={<AgentsPage />} />
        <Route path="/admin/impostazioni" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
